import Vue from 'vue'
import Router from 'vue-router'

import admin from '@/admin'

import home from '@/home'
import login from '@/login'
import register from '@/register'
import protocol from '@/protocol'
import forgetpassword from '@/forgetpassword'

import balance from '@/balance'
import recharge from '@/recharge'
import integral from '@/integral'
// import integralexplanation from '@/integralexplanation'

import mycard from '@/mycard'
import cardtransfer from '@/cardtransfer'

import myorder from '@/myorder'

import process from '@/process'

import message from '@/message'

import help from '@/help'

import parcel from '@/parcel'

import seal from '@/seal'

import rentsrecharge from '@/rentsrecharge'

import rentsreturn from '@/rentsreturn'

import cardcenter from '@/cardcenter'

import orderinfo from '@/orderinfo'

import vip from '@/vip'
import vipbuy from '@/vipbuy'
import profit from '@/profit'
import invitation from '@/invitation'
import withdrawal from '@/withdrawal'
import share from '@/share'
import invite from '@/invite'

Vue.use(Router)
var myrouter = new Router({
    routes: [

        {
            path: '*',
            name: 'basic',
            redirect: '/admin',
        },

        {
            path: '/protocol',
            name: 'protocol',
            component: protocol,
            meta: {
                title: '注册协议'
            }
        },

        // {
        //     path: '/integralexplanation',
        //     name: 'integralexplanation',
        //     component: integralexplanation,
        //     meta: {
        //         title: '积分说明'
        //     }
        // },



        {
            path: '/recharge',
            name: 'recharge',
            component: recharge,
            meta: {
                title: '充值'
            }
        },

        {
            path: '/vip',
            name: 'vip',
            component: vip,
            meta: {
                title: '年费会员'
            }
        },
        {
            path: '/vipbuy',
            name: 'vipbuy',
            component: vipbuy,
            meta: {
                title: '年费会员'
            }
        },
        {
            path: '/withdrawal',
            name: 'withdrawal',
            component: withdrawal,
            meta: {
                title: '提现'
            }
        },
        {
            path: '/share',
            name: 'share',
            component: share,
            meta: {
                title: '推广'
            }
        },
        {
            path: '/invite',
            name: 'invite',
            component: invite,
            meta: {
                title: '推广'
            }
        },





        {
            path: '/message',
            name: 'message',
            component: message,
            meta: {
                title: '消息中心'
            }
        },



        {
            path: '/orderinfo',
            name: 'orderinfo',
            component: orderinfo,
            meta: {
                title: '订单详情'
            }
        },




        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: '登录'
            }
        },


        {
            path: '/register',
            name: 'register',
            component: register,
            meta: {
                title: '注册'
            }
        },


        {
            path: '/forgetpassword',
            name: 'forgetpassword',
            component: forgetpassword,
            meta: {
                title: '忘记密码'
            }
        },

        {
            path: '/parcel',
            name: 'parcel',
            component: parcel,
            meta: {
                title: '上门服务'
            }
        },


        {
            path: '/admin',
            name: 'admin',
            component: admin,
            redirect: '/admin/home',
            children: [


                {
                    path: '/admin/home',
                    name: 'home',
                    component: home,
                    meta: {
                        title: '会员中心'
                    }
                },
                {
                    path: '/admin/cardcenter',
                    name: 'cardcenter',
                    component: cardcenter,
                    meta: {
                        title: '卡券中心'
                    }
                },
                {
                    path: '/admin/process',
                    name: 'process',
                    component: process,
                    meta: {
                        title: '洗衣流程'
                    }
                },

                {
                    path: '/admin/balance',
                    name: 'balance',
                    component: balance,
                    meta: {
                        title: '余额'
                    }
                },

                {
                    path: '/admin/integral',
                    name: 'integral',
                    component: integral,
                    meta: {
                        title: '我的积分'
                    }
                },

                {
                    path: '/admin/mycard',
                    name: 'mycard',
                    component: mycard,
                    meta: {
                        title: '我的卡券'
                    }
                },

                {
                    path: '/admin/help',
                    name: 'help',
                    component: help,
                    meta: {
                        title: '帮助中心'
                    }
                },




                {
                    path: '/admin/cardtransfer',
                    name: 'cardtransfer',
                    component: cardtransfer,
                    meta: {
                        title: '卡卷转赠'
                    }
                },

                {
                    path: '/myorder',
                    name: 'myorder',
                    component: myorder,
                    meta: {
                        title: '订单列表'
                    }
                },

                {
                    path: '/admin/seal',
                    name: 'seal',
                    component: seal,
                    meta: {
                        title: '我的印章'
                    }
                },

                {
                    path: '/admin/profit',
                    name: 'profit',
                    component: profit,
                    meta: {
                        title: '我的收益'
                    }
                },
                {
                    path: '/admin/invitation',
                    name: 'invitation',
                    component: invitation,
                    meta: {
                        title: '我的邀请'
                    }
                },





                {
                    path: '/admin/rentsrecharge',
                    name: 'rentsrecharge',
                    component: rentsrecharge,
                    meta: {
                        title: '租金充值'
                    }
                },

                {
                    path: '/admin/rentsreturn',
                    name: 'rentsreturn',
                    component: rentsreturn,
                    meta: {
                        title: '租金退回'
                    }
                },



            ]
        },

    ]
})
myrouter.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
export default myrouter;


// WEBPACK FOOTER //
// ./src/router/index.js